// auth
export const TOKEN_KEY = 'ruminatiToken'
export const REFRESH_TOKEN_KEY = 'ruminatiRefreshToken'
export const USER_KEY = 'ruminatiUser'
export const VERIFIED_KEY = 'ruminatiVerified'
export const SESSION_COOKIE_EXPIRY_LENGTH = 1000 * 60 * 60 * 24 * 30 // 30 days
export const NEW_PASSWORD_MIN_LENGTH = 12
export const EMAIL_VERIFICATION_RESEND_COOLDOWN_SECONDS = 60
export const OAUTH_CODE_VERIFIER_COOKIE_KEY = 'oauth_code_verifier'
export const OAUTH_STATE_COOKIE_KEY = 'oauth_state'
export const OAUTH_NONCE_COOKIE_KEY = 'oauth_nonce'
export const OAUTH_AGRIWEBB_STATE_COOKIE_KEY = 'oauth_agriwebb_state'
export const OAUTH_REGISTER_PROMO_CODE_COOKIE_KEY = 'oauth_register_promo_code'
export const OAUTH_REGISTER_VISION_ORG_ID_COOKIE_KEY = 'oauth_register_vision_org_id'
export const OAUTH_REGISTER_VISION_ORG_CLIENT_REFERENCE_ID_COOKIE_KEY =
  'oauth_register_vision_org_client_reference_id'
export const OAUTH_REGISTER_VISION_VOUCHER_POOL_COOKIE_KEY = 'oauth_register_vision_voucher_pool'
export const OAUTH_REGISTER_RELATIONSHIP_ID_COOKIE_KEY = 'oauth_register_relationship_id'
export const OAUTH_REDIRECT_TO_COOKIE_KEY = 'oauth_redirect_to'

export const COOKIE_PREFIX = 'ruminati'
export const CURRENT_USER_ID_COOKIE_SUFFIX = 'userid'
export const CURRENT_ORGANISATION_ID_COOKIE_SUFFIX = 'current_org_id'
export const SESSION_COOKIE_SUFFIX = 'session'
export const CURRENT_PROVIDER_COOKIE_SUFFIX = 'provider'

// GCP
export const GOOGLE_REFRESH_TOKEN_URL = `https://securetoken.googleapis.com/v1/token`
export const GOOGLE_IDENTITY_ACCOUNTS_URL = 'https://identitytoolkit.googleapis.com/v1/accounts'

export const GOOGLE_IDENTITY_SIGNUP_PARAM = 'signUp'
export const GOOGLE_IDENTITY_SIGNUP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGNUP_PARAM}`

export const GOOGLE_IDENTITY_SIGNIN_PARAM = 'signInWithPassword'
export const GOOGLE_IDENTITY_SIGNIN_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGNIN_PARAM}`

export const GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_PARAM = 'sendOobCode'
export const GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SEND_EMAIL_VERIFICATION_PARAM}`

export const GOOGLE_IDENTITY_RESET_PASSWORD_PARAM = 'resetPassword'
export const GOOGLE_IDENTITY_RESET_PASSWORD_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_RESET_PASSWORD_PARAM}`

export const GOOGLE_IDENTITY_UPDATE_PARAM = 'update'
export const GOOGLE_IDENTITY_UPDATE_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_UPDATE_PARAM}`

export const GOOGLE_IDENTITY_USER_LOOKUP_PARAM = 'lookup'
export const GOOGLE_IDENTITY_USER_LOOKUP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_USER_LOOKUP_PARAM}`

export const GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_PARAM = 'signInWithIdp'
export const GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_SIGN_IN_WITH_IDP_PARAM}`

export const GOOGLE_IDENTITY_DELETE_PARAM = 'delete'
export const GOOGLE_IDENTITY_DELETE_URL = `${GOOGLE_IDENTITY_ACCOUNTS_URL}:${GOOGLE_IDENTITY_DELETE_PARAM}`

// tasks
export const HELP_AGENT_QUEUE = 'help_agent'
export const HELP_AGENT_TASK = 'help-agent-turn'

// TypeBox
export const TB_ERROR_REQUIRED = 'Expected required property'
export const TB_ERROR_ARRAY_REQUIRED = 'Expected array length to be greater or equal to 1'
export const TB_ERROR_STRING_REQUIRED = 'Expected string length greater or equal to 1'

// new-server Identity Platform REST API endpoints
export function getIdentityPlatformAPIEndpoints(targetProjectId: string) {
  // the admin SDK generally uses the project endpoint, but not all functionality we require has a project endpoint
  const baseIdentityPlatformProjectEndpoint =
    `https://identitytoolkit.googleapis.com/v1/projects/${targetProjectId}` as const
  const baseIdentityPlatformEndpoint = `https://identitytoolkit.googleapis.com/v1` as const
  return {
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/projects/accounts
    userCreate: `${baseIdentityPlatformProjectEndpoint}/accounts` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/projects.accounts/update
    userUpdate: `${baseIdentityPlatformProjectEndpoint}/accounts:update` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/projects.accounts/lookup
    userLookup: `${baseIdentityPlatformProjectEndpoint}/accounts:lookup` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/projects.accounts/delete
    userDelete: `${baseIdentityPlatformProjectEndpoint}/accounts:delete` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/projects.accounts/sendOobCode
    sendOobCode: `${baseIdentityPlatformProjectEndpoint}/accounts:sendOobCode` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/accounts/resetPassword
    // N.B. uses the "resetPassword" endpoint (who knows why)
    checkOobCode: `${baseIdentityPlatformEndpoint}/accounts:resetPassword` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/accounts/signInWithPassword
    userLoginWithCredentials:
      `${baseIdentityPlatformEndpoint}/accounts:signInWithPassword` as const,
    // https://cloud.google.com/identity-platform/docs/reference/rest/v1/accounts/resetPassword
    resetPassword: `${baseIdentityPlatformEndpoint}/accounts:resetPassword` as const,
  }
}
